import './courseCard.scss'
import { capitalizeAllLetter, convertDateFormat } from '../../utility/genricFunction'
import BranchIcon from '../../assets/icons/BranchIcon.svg'
import dateIcon from '../../assets/icons/TimeTable.svg'
import tableDotIcon from '../../assets/icons/tableDot.svg'
import { useNavigate } from 'react-router-dom'

function CourseCard({ course }) {
  const navigator = useNavigate()

  function handleCardClick() {
    navigator(`/dashboard/course-details/${course?.courseId}`)
  }

  return (
    <div className='course-card-wrapper' onClick={handleCardClick}>
      <div className='course-card-header'>
        {course.courseExamFormat.map((item, index) => {
          return (
            <span className='mcq-span' key={index}>
              {capitalizeAllLetter(item)}
            </span>
          )
        })}
        <span className='course-status-span'>{capitalizeAllLetter(course?.userStatus)}</span>
      </div>

      <div className='course-card-main'>
        <p className='course-title'>{course?.courseName}</p>

        <div className='course-card-details'>
          <span>
            <img src={BranchIcon} alt='branchIcon' /> {course?.area || 'N/A'}, {course?.city || 'N/A'}
          </span>
          <span>
            <img src={dateIcon} alt='dateIcon' /> END: {convertDateFormat(course?.batchEndDate)}
          </span>
        </div>
      </div>

      <div className='course-card-footer'>
        <div className='course-card-details'>
          <span>{course?.totalModuleCount}</span> Modules <div className='saprater-div'></div>
          <span>{course?.totalTopicCount}</span> Topics <div className='saprater-div'></div>
          <span>{course?.totalDocumentCount}</span> PDF <div className='saprater-div'></div>
          <span>{course?.totalVideoCount}</span> Videos
        </div>
        <img src={tableDotIcon} alt='icon' />
      </div>
    </div>
  )
}

export default CourseCard
